import { createEvent } from "react-event-hook";

export type Message = {
  code: string;
  message: string;
};
export const { useErrorListener, emitError } = createEvent("error")<Message>();
export const { useReloadListener, emitReload } = createEvent("reload")();
